import React from "react";
import PropTypes from "prop-types";
import {ResponsiveDialog} from "@hapinest/theme";
import {makeStyles, Grid, Typography} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    alertCircle: {
        fontSize: theme.spacing(4.5)
    },
    textAlignCenter: {
        textAlign: "center"
    },
    img: {
        width: theme.spacing(12.5),
        height: theme.spacing(12.5),
    },
    mb2: {
        marginBottom: theme.spacing(2)
    },
    mt6: {
        marginTop: theme.spacing(6)
    }
}));

const BuySellPointsErrorDialog = ({
    open,
    imageError,
    handleClose,
    title,
    description,
    actions,
}) => {
    const classes = useStyles();

    return (
        <ResponsiveDialog
            disableBackdropClick
            disableEscapeKeyDown
            open={open}
            handleClose={handleClose}
            maxWidth="xs"
            title={
                <Grid
                    container
                    justify={"center"}
                    className={classes.mt6}
                >
                    <img
                        className={classes.img}
                        src={imageError}
                    />
                </Grid>
            }
            content={
                <Grid
                    container
                    direction={"column"}
                    justify={"center"}
                    className={classes.textAlignCenter}
                >
                    <Grid item>
                        <Typography
                            variant={"h4"}
                            className={classes.mb2}
                        >
                            {title}
                        </Typography>

                        <Typography variant={"body1"}>
                            {description}
                        </Typography>
                    </Grid>
                </Grid>
            }
            actions={actions}
        />
    );
};

BuySellPointsErrorDialog.propTypes = {
    open: PropTypes.bool,
    imageError: PropTypes.string,
    handleClose: PropTypes.any,
    title: PropTypes.string,
    description: PropTypes.string,
    actions: PropTypes.any,
};

export default BuySellPointsErrorDialog;
